module.exports = __webpack_public_path__ + "static/media/Logo_CCI_france.4fbe0c4b.svg";